var map = {
	"./portfolio-1.jpg": 78282,
	"./portfolio-2.jpg": 20056,
	"./portfolio-3.jpg": 90557,
	"./portfolio-4.jpg": 91525,
	"./portfolio-5.jpg": 52925,
	"./portfolio-6.jpg": 7800,
	"./portfolio-7.jpg": 81208,
	"./portfolio-8.jpg": 16316,
	"./portfolio-9.jpg": 75266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1185;